import "./Timeline.css";

/*
  Timeline Component

  A vertical list of events (request history). Only what is passed is shown:
  an item without actor / time / note simply omits that line (nothing is
  invented). Newest or oldest first is the caller's choice.

  items  [{ key, title, meta, note, tag }]
           title  the event (text)
           meta   e.g. "Amal · am · 12 Oct 2026, 10:30"
           note   optional free text (notes / reasons the viewer may see)
           tag    optional node (e.g. a status tag)
  label  accessible name of the list
*/

const Timeline = ({ items = [], label, className = "" }) => (
  <ol className={`ui-timeline ${className}`} aria-label={label}>
    {items.map((item, index) => (
      <li key={item.key ?? index} className="ui-timeline-item">
        <span className="ui-timeline-dot" aria-hidden="true" />
        <div className="ui-timeline-body">
          <div className="ui-timeline-head">
            <strong>{item.title}</strong>
            {item.tag}
          </div>
          {item.meta && <span className="ui-timeline-meta">{item.meta}</span>}
          {item.note && <p className="ui-timeline-note">{item.note}</p>}
        </div>
      </li>
    ))}
  </ol>
);

export default Timeline;
